import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootStrapVue from "bootstrap-vue";
import VueKonva from "vue-konva";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootStrapVue);
Vue.use(VueKonva);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
